module.exports = __webpack_public_path__ + "static/media/logo_uniongroup-dark.768febd7.png";